/**
 * Full Screen Manager - Moon Moon Agency
 * Ajuste dynamiquement la font-size du titre fluide pour qu'il remplisse
 * 100% de la largeur de son conteneur sans déformation ni étirement.
 */

/*********************************************************************************************
 * 🔧 FULL SCREEN MANAGER
 *
 * Garde d'idempotence : la section peut être présente plusieurs fois sur une page,
 * chaque instance injecte ce script. `const` au scope global lèverait alors
 * "Identifier already declared". On expose sur window et on sort si déjà défini.
 */
if (!window.FullScreenManager) {

const FullScreenManager = {
	config: {
		selectors: {
			fitText: '[data-mm-fit-text]',
		},
		classes: {
			fitted: 'is-fitted',
			measure: 'mm-fit-measure',
		},
		sizing: {
			min: 16,
			max: 1200,
			safety: 0.98,
		},
		timing: {
			resizeDebounce: 150,
		},
	},

	init() {
		const titles = window.getElements(this.config.selectors.fitText);
		if (!titles || !titles.length) return;

		this.titles = titles;
		this.titles.forEach((el) => this._fit(el));
		this._bindEvents();

		window.log('info', '🔧 [FULL_SCREEN]', 'Initialized', { count: titles.length });
	},

	_bindEvents() {
		if (this._resizeHandler) {
			window.removeEventListener('resize', this._resizeHandler);
		}
		this._resizeHandler = window.debounce(
			() => this.titles.forEach((el) => this._fit(el)),
			this.config.timing.resizeDebounce,
		);
		window.addEventListener('resize', this._resizeHandler);

		// Re-fit après chargement des fonts (évite décalage FOUT)
		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(() => {
				this.titles.forEach((el) => this._fit(el));
			});
		}
	},

	_getTargetWidth(parent) {
		const rect = parent.getBoundingClientRect();
		const styles = window.getComputedStyle(parent);
		const paddingX =
			parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
		const borderX =
			parseFloat(styles.borderLeftWidth) + parseFloat(styles.borderRightWidth);
		return rect.width - paddingX - borderX;
	},

	_fit(el) {
		// Mobile : taille fixe gérée en CSS
		if (window.isMobile()) {
			el.style.fontSize = '';
			el.classList.add(this.config.classes.fitted);
			return;
		}

		const parent = el.parentElement;
		if (!parent) return;

		const targetWidth = this._getTargetWidth(parent) * this.config.sizing.safety;
		if (targetWidth <= 0) return;

		// Span inline interne pour mesurer le texte (sinon scrollWidth = width du block)
		let measure = el.querySelector('.' + this.config.classes.measure);
		if (!measure) {
			measure = document.createElement('span');
			measure.className = this.config.classes.measure;
			measure.style.cssText =
				'display:inline-block;white-space:nowrap;' +
				'font:inherit;letter-spacing:inherit;line-height:inherit;color:inherit;';
			measure.textContent = el.textContent;
			el.textContent = '';
			el.appendChild(measure);
		}

		// Binary search : plus grand font-size où la mesure tient dans targetWidth
		let low = this.config.sizing.min;
		let high = this.config.sizing.max;
		let best = low;

		while (low <= high) {
			const mid = Math.floor((low + high) / 2);
			el.style.fontSize = mid + 'px';

			if (measure.getBoundingClientRect().width <= targetWidth) {
				best = mid;
				low = mid + 1;
			} else {
				high = mid - 1;
			}
		}

		el.style.fontSize = best + 'px';
		el.classList.add(this.config.classes.fitted);
	},
};

// Auto-init avec vérification readyState
if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => FullScreenManager.init());
} else {
	FullScreenManager.init();
}

// Customizer Shopify : re-init si la section concernée est rechargée
document.addEventListener('shopify:section:load', (e) => {
	if (e.target && e.target.querySelector(FullScreenManager.config.selectors.fitText)) {
		FullScreenManager.init();
	}
});

// Exposition globale pour la garde d'idempotence ci-dessus
window.FullScreenManager = FullScreenManager;

}
